import { isAccountsRiverrDomain } from "../utils";

const CLARITY_PROJECT_ID = (
  process.env.REACT_APP_CLARITY_PROJECT_ID || "y4xm6rx07d"
).trim();

const CLARITY_ENABLED =
  isAccountsRiverrDomain && /^[a-zA-Z0-9_-]{1,30}$/.test(CLARITY_PROJECT_ID);

const EVENT_BY_PATH = {
  "/register": "register_viewed",
  "/onboarding/business": "onboarding_business",
  "/onboarding/production": "onboarding_production",
  "/onboarding/sales": "onboarding_sales",
  "/onboarding/branding": "onboarding_branding",
  "/onboarding/pricing": "onboarding_pricing",
  "/onboarding/products": "onboarding_products",
  "/onboarding/print-options": "onboarding_print_options",
  "/onboarding/store": "onboarding_store",
  "/onboarding/complete": "onboarding_complete",
};

function normalizePath(pathname) {
  if (!pathname) return "/";
  return pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;
}

export function injectAccountsClarity() {
  if (!CLARITY_ENABLED || typeof window === "undefined") return;
  if (document.getElementById("clarity-script")) return;

  (function (c, l, a, r, i) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    const t = l.createElement(r);
    t.id = "clarity-script";
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);

  try {
    window.clarity("set", "site", "accounts");
  } catch {
    // Analytics must never block UX.
  }
}

export function trackAccountsClarity(name) {
  if (!CLARITY_ENABLED || typeof window === "undefined" || !name) return;
  try {
    window.clarity?.("event", name);
  } catch {
    // Analytics must never block UX.
  }
}

export function trackAccountsClarityPath(pathname) {
  const event = EVENT_BY_PATH[normalizePath(pathname)];
  if (event) trackAccountsClarity(event);
}
